// removed by extract-text-webpack-plugin
module.exports = {"page_buy":"app__css__app-pages-SelfHelp-choosePhoneNum-__index__page_buy","step-input":"app__css__app-pages-SelfHelp-choosePhoneNum-__index__step-input","btn_icon":"app__css__app-pages-SelfHelp-choosePhoneNum-__index__btn_icon"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/SelfHelp/choosePhoneNum/index.css
// module id = 1568
// module chunks = 0